<template>
  <div class="fx_Bmap_container" :ref="ref">
    <div class="fx_Bmap_top">
      <slot></slot>
    </div>
    <div :style="{'height':`${chartHeight}`,'flex':1}">
      <div class="fx_Bmap" :ref="chartRef"></div>
    </div>

  </div>
</template>
<script>
import Echarts from 'echarts'
import 'echarts/extension/bmap/bmap'
// import { getMapScript } from '../../../src/util/index.js'
import autoResize from '../../../src/mixins/autoResize'

export default {
  name: 'fxBmap1',
  mixins: [autoResize],
  data() {
    const timestamp = Date.now()
    return {
      ref: `map-container-${timestamp}`,
      chartRef: `map-${timestamp}`,
      // titleRef: `title-${timestamp}`,
      myChart: null,
      config: {},
      chartHeight: '100%',
      geoData: {
        name: '',
        json: {}
      },
      operateRef: `edit-${timestamp}`
    }
  },
  props: {
    events: {
      deep: true,
      handler: 'createEventProxy'
    },
    geoJson: {},
    geoName: {
      type: String
    }
  },
  computed: {},
  watch: {
    config: {
      handler(newVal, oldVal) {
        let { myChart } = this
        const { option, title, geoData } = this.config
        if (!myChart) return
        if (!option) option = {}
        if(geoData){
          let {name,json} = geoData
          Echarts.registerMap(name, json)
        }
        this.myChart.setOption(option, true)
      },
      deep: true
      // immediate:true
    },

    events: {
      deep: true,
      handler: 'createEventProxy'
    },

    geoData: {
      handler(newVal, oldVal) {
        if (!newVal) return
        let { name, json } = newVal
        if (!name) return
        if (!json) return
        Echarts.registerMap(name, json)
      }
    }
  },
  methods: {
    initEchart() {
      //初始化echarts实例
      const { $refs, chartRef } = this
      const { option } = this.config

      const myChart = (this.myChart = Echarts.init($refs[chartRef]))
      if (!option) return

      myChart.setOption(option)
    },
    afterAutoResizeMixinInit() {
      const { initEchart } = this
      initEchart()
    },
    onResize() {
      // 自适应
      const { myChart } = this
      if (!myChart) return
      myChart.resize()
    },
    getChart() {
      let { myChart } = this
      if (!myChart) return
      return myChart
    },

    //设置config
    setConfig(param = {}) {
      this.config = param
    },
    setMap(param = {}) {
      this.geoData = param
    },
    createEventProxy() {
      // 只要用户使用 on 方法绑定的事件都做一层代理，
      // 是否真正执行相应的事件方法取决于该方法是否仍然存在 events 中
      // 实现 events 的动态响应
      const self = this
      const keys = Object.keys(this.events || {})
      keys.length &&
        keys.forEach(ev => {
          if (this.registeredEvents.indexOf(ev) === -1) {
            this.registeredEvents.push(ev)
            this.myChart.on(
              ev,
              (function(ev) {
                return function(...args) {
                  if (ev in self.events) {
                    self.events[ev].apply(null, args)
                  }
                }
              })(ev)
            )
          }
        })
    }
  },
  created() {
    this.registeredEvents = []
    // Echarts.registerMap(this.geoName, this.geoJson)
  },
  async mounted() {
    // console.log(this._BMap());

    // await getMapScript(this._BMap())

    this.$nextTick(() => {
      this.initEchart()
    })
  }
}
</script>
<style lang="scss" scoped>
.fx_Bmap_container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .fx_Bmap_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
  }
  .fx_Bmap {
    width: 100%;
    height: 100%;
  }
}
.panel {
  // position: fixed;
  // top: 0;
  // right: 0;
  // bottom: 0;
  // left: 50%;
  background: #ffffff;
}

.right-enter {
  opacity: 1;
  transform: translateX(100%);
}
.right-leave-to {
  opacity: 1;
  transform: translateX(100%);
}

.right-enter-active {
  transition: all 0.3s ease;
}
.right-leave-active {
  transition: all 0.4s ease;
}

.left-enter {
  opacity: 1;
  transform: translateX(-100%);
}
.left-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.left-enter-active,
.left-leave-active {
  transition: all 0.3s ease;
}
</style>